// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_i-zyB","tag":"tag_3pVYc","icon":"icon_iSbNF"};